import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '@/lib/cn';
const variantClasses = {
    // Primary CTA uses the Styxtech brand lime — brand-500 base, brand-600
    // hover, brand-700 active. Per the brand mapping in src/styles.css.
    primary: 'bg-brand-500 text-white shadow-brand hover:bg-brand-600 active:bg-brand-700',
    secondary: 'bg-slate-900 text-white hover:bg-slate-800 dark:bg-slate-200 dark:text-slate-900 dark:hover:bg-white',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100',
    danger: 'bg-rose-600 text-white shadow-sm hover:bg-rose-700 active:bg-rose-800',
    outline: 'border border-slate-300 bg-white text-slate-700 shadow-sm hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800',
};
const sizeClasses = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base',
};
export const Button = forwardRef(({ className, variant = 'primary', size = 'md', ...rest }, ref) => (_jsx("button", { ref: ref, className: cn('inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-950 active:scale-[0.98]', variantClasses[variant], sizeClasses[size], className), ...rest })));
Button.displayName = 'Button';
